import { IntlShape } from 'react-intl'
import { create, enforce, omitWhen, test } from 'vest'
import {
  NominalShipping,
  RegularBenefitVariant,
} from '../../../../../../../typings'
import { validationShippingVariantSuite } from '../../../../../../ShippingVariantSelector/validation'
import { messages } from './messages'

export function validationSuiteNominalShipping(intl: IntlShape) {
  return create((props: NominalShipping) => {
    const { value, type } = props
    const { $t } = intl
    const { validation } = messages

    omitWhen(type !== RegularBenefitVariant.NominalShipping, () => {
      omitWhen(value === undefined, () => {
        test('value', $t(validation.greaterThan, { value: 0 }), () => {
          enforce(value).greaterThan(0)
        })
      })

      test('value', $t(validation.required), () => {
        enforce(value).isNotEmpty()
      })

      validationShippingVariantSuite(intl)(props as NominalShipping)
    })
  })
}
